import React, { useContext, useEffect, useState } from "react";
import { WYLearn } from "../../../Mock/Learn";
import * as FaIcons from "react-icons/fa";
import SecondaryHeading from "../../../utils/SecondaryHeading/SecondaryHeading";
import PrimaryBtn from "../../../utils/PrimaryBtn/PrimaryBtn";
import axios from "axios";
import Loading from "../../../utils/Loader/Loading";
import Timer from "../../../main/Timer/Timer";
import { MyContext } from "../../../pages/Funnel";

const WYL = ({ id }) => {
  let [state, setState] = useState([]);
  let [isLoading, setIsLoading] = useState(true);
  let [isError, setIsError] = useState(false);

  useEffect(() => {
    let fetchCards = async () => {
      try {
        let response = await axios.get(
          `https://vercel-deployment-w4ja.onrender.com/api/learn_content_get/${id}`
        );
        setState(response.data.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCards();
  }, []);

  return (
    <>
      {isLoading && (
        <div className="my-50 flex justify-center items-center h-screen">
          <Loading />
        </div>
      )}
      {!isLoading && !isError && state.length !== 0 && (
        <section className="max-w-7xl m-auto mt-16 max-sm:px-5">
          <div className="flex justify-center mb-10">
            <SecondaryHeading>What You Will Learn</SecondaryHeading>
          </div>
          <div className="grid grid-cols-3 gap-10 max-sm:grid-cols-1">
            {state.map((val, index) => (
              <Child key={index} {...val} index={index} />
            ))}
          </div>
          <div>
            <div className="flex justify-center flex-col items-center mt-10">
              <Timer />
              <PrimaryBtn>Enroll Now</PrimaryBtn>
            </div>
          </div>
        </section>
      )}
      {isError && "Error Occurred"}
    </>
  );
};

export default WYL;

const Child = ({ icon, title, description, index }) => {
  const IconComponent = FaIcons[icon] || FaIcons.FaQuestion;
  const { state: details } = useContext(MyContext);

  return (
    <div
      style={{ backgroundColor: details.color }}
      className="bg-primary text-white rounded-md py-10 px-6 flex justify-center flex-col items-center">
      <IconComponent className="text-5xl mb-9 " />

      <h3 className="mb-8 text-2xl text-center max-sm:text-xl">
        <span>{index + 1}.</span> {title}
      </h3>
      <p className="text-center font-light max-sm:text-base">{description}</p>
    </div>
  );
};
